import { t } from 'i18next'

import {
  normalizeTriage,
  toConversation,
} from '@/state/eventHandlers/initialData'
import { AppState } from '@/state/stateType'
import { updateProp } from '@/util/object'
import { ConversationCreatedEvent } from '~common/serverToClientParser'

export default function handleConversationCreated(
  state: AppState,
  ev: ConversationCreatedEvent,
): AppState {
  const c = ev.conversation
  const isForUser = !!state.user.userGroups.find(
    (group) => group.id === c.userGroupId,
  )

  if (!isForUser) {
    return state
  }

  new Notification(
    t('chat.notifications.conversationCreated', { user: c.patient?.name }),
  )

  return updateProp(state, 'conversations', (conversations) =>
    conversations.concat([
      {
        ...toConversation(c),
        triage: normalizeTriage(ev.triage),
      },
    ]),
  )
}
